import WorkerStatus from "@/models/Workers/WorkerStatus";
import WorkType from "@/models/Shared/WorkType";
import SearchMatchType from "@/models/Shared/SearchMatchType";

export default class WorkerProfileSearchRequest {
    statuses: WorkerStatus[] = [];
    isAgreedToMarketing = true;
    workTypes: WorkType[] = [];
    positionCodes: string[] = [];
    currentPositionCode = '';
    annualSalaryMax = 0;
    skillCodes: string[] = [];
    skillMatchType: SearchMatchType = SearchMatchType.All;
    qualificationCodes: string[] = [];
    qualificationMatchType: SearchMatchType = SearchMatchType.All;
    availability: string[] = [];
    availabilityDateSlots: string[] = [];
    latitude = 0;
    longitude = 0;
    distance = 0;
    driversOnly = false;
    minimumPassengers = 0;
    locationId = '';
    branchId = '';
    deskId = '';
    isFavouritesOnly = true;
    isIncludeBlocked = false;
}